import React, { Component } from 'react';
import { translate } from 'react-i18next';

import './Info.css';

class Info extends Component {

  render() {
    const { t, variant, data } = this.props;

    return (
      <div className='infoModalContainer'>
        { variant === 'flight' ?
          <div className='infoFlight'>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_id')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'id vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.name')}
              </div>
              <div className='row attribute-value'>
                {data.title}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.type')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Tipo vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.typology')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Tipología vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.date_flight')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Fecha')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.scale')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Escala')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.registers_number')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Número fotogramas')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.color')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Color')[0].value}
              </div>
            </div>
          </div>
        : <div className='infoFotogram'>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.fotogram_id')}
              </div>
              <div className='row attribute-value'>
                {data.name.split('_').join('-')}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.date')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Fecha Fotograma')[0].value.split('-').reverse().join('/')}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.ellipsoid')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Elipsoide')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.zone')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Huso')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.municipality')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Municipio')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.province')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Provincia')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Titulo Vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_type')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Tipo vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.flight_typologoy')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Tipología vuelo')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.scale')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Escala')[0].value}
              </div>
            </div>
            <div className='attributeField'>
              <div className='row attribute-title'>
                {t('info.sheet')}
              </div>
              <div className='row attribute-value'>
                {data.extras.filter((e) => e.key === 'Hoja MTN50')[0].value}
              </div>
            </div>
          </div> }
      </div>
    );
  }
}

export default translate()(Info);
